<div class="form-group">
  <label class="form-control-label" *ngIf="show_title == true" for="email">{{ title }}</label>

  <input
    class="form-control"
    [id]="id"
    [name]="name"
    [type]="type"
    [disabled]="readonly === true || readonly === 'true'"
    [placeholder]="placeholder || title"
    [ngClass]="{ 'is-invalid': !input.valid && !isReadonly && input.touched }"
    #input="ngModel"
    [required]="!isReadonly && required"
    [minlength]="!isReadonly ? minlength : null"
    aria-describedby="inputGroup-sizing-sm"
    [maxlength]="!isReadonly ? maxlength : null"
    [pattern]="!isReadonly ? pattern : null"
    [ngModel]="value"
    (ngModelChange)="onInputChange($event)"
  />

  @if (!input.valid && input.touched) {
    <label
      *ngIf="input.errors?.['required']"
      id="validation-email-error"
      class="error jquery-validation-error small form-text invalid-feedback d-block"
    >
      {{ title }} is required.
    </label>
    <label
      *ngIf="input.errors?.['minlength']"
      id="validation-email-error"
      class="error jquery-validation-error small form-text invalid-feedback d-block"
    >
      Minimum length is {{ minlength }} characters
    </label>
    <label
      *ngIf="input.errors?.['maxlength']"
      id="validation-email-error"
      class="error jquery-validation-error small form-text invalid-feedback d-block"
    >
      Maximum length is {{ maxlength }} characters.
    </label>
    <label
      *ngIf="input.errors?.['pattern'] || input.errors?.['email']"
      id="validation-email-error"
      class="error jquery-validation-error small form-text invalid-feedback d-block"
    >
      {{ patternError || 'Invalid Pattern' }}
    </label>
  }
</div>
